import React from 'react';
import AboutMe from '../components/AboutMe/AboutMe';
import TimelineContainer from '../components/Timeline/TimelineContainer';
import VerticalTimelineContainer from '../components/VerticalTimeline/VerticalTimelineContainer';
import TechContainer from '../components/Tech/TechContainer';
import WelcomeContainer from '../components/Welcome/WelcomeContainer';

const IndexPage = () => (
  <div>
    <WelcomeContainer />
    <AboutMe />
    <VerticalTimelineContainer />
    <TechContainer />
    <TimelineContainer />
  </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js